<template>
    <div class="modal-goodslist" :style="goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">入账订单详情</div>
                <el-button type="danger" @click="closeSelf">关闭</el-button>
            </div>
            
            <div class="modal-body" :style="bodyStyle">
                <el-row>
                    <Search :searchForm='searchForm' :searchData='searchData' v-on:getList='getList' ref="Search"></Search>
                    <el-col :span="24" style="margin-top:10px">
                        <el-table :data="tableData" v-loading="loading" style="width: 100%" border :height="th" >
                        <el-table-column prop="serialNumber" label="订单流水号" width="300" ></el-table-column>
                        <el-table-column prop="user.name" width="105" label="老人姓名" ></el-table-column>
                        <el-table-column prop="user.phone" width="150" label="手机号" ></el-table-column>
                        <el-table-column prop="businessName" width="150" label="商家名称" ></el-table-column>
                        <el-table-column prop="listOrderGoodsDTO" label="商品名称" width="250">
                            <template scope="scope">
                                <div style="width: 100%;" v-for="list in scope.row.listOrderGoodsDTO" v-bind:key="list.orderGoodsCode">
                                    <p style="width: 100%">{{list.goodsName}}</p>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="listOrderGoodsDTO" label="单价(元)" width="105">
                              <template scope="scope">
                                <div style="width: 100%;" v-for="list in scope.row.listOrderGoodsDTO" v-bind:key="list.orderGoodsCode">
                                    <p style="width: 100%">{{list.goodsPrice}}</p>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="orderGoodsAttribute" label="商品属性" width="200">
                             <template scope="scope">
                                <div style="width: 100%;" v-for="list in scope.row.listOrderGoodsDTO" v-bind:key="list.orderGoodsCode">
                                    <p style="width: 100%">{{list.orderGoodsAttribute}}</p>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="number" width="105" label="购买数量">
                             <template scope="scope">
                                <div style="width: 100%;" v-for="list in scope.row.listOrderGoodsDTO" v-bind:key="list.orderGoodsCode">
                                    <p style="width: 100%">{{list.number}}</p>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="price" :formatter="getPrice"  width="105"  label="总价(元)" ></el-table-column>
                        <el-table-column prop="orderFrom" :formatter="getOrderFrom"  width="105" label="订单来源" ></el-table-column>
                        <el-table-column  prop="status" :formatter="statuss"  width="105" label="订单状态"></el-table-column>
                        <el-table-column prop="orderType" :formatter="statusTitle" width="120" label="订单类型"></el-table-column>
                        <el-table-column prop="createTime" :formatter="timefilter" width="180" label="下单时间"></el-table-column>
                        <el-table-column prop="serveName" label="服务人员" width="85"></el-table-column>
                        <el-table-column prop="orderServe.startTime" :formatter="getSETime" width="200" label="服务开始时间"></el-table-column>
                        <el-table-column prop="orderServe.endTime" :formatter="getSETime" width="200" label="服务结束时间"></el-table-column>
                        <el-table-column prop="orderLogistics.expressNumber" label="物流单号" width="310"></el-table-column>
                        <el-table-column prop="orderLogistics.remarks" label="快递名称" width="120"></el-table-column>
                        <el-table-column prop="orderLogistics.sendTime" label="发货时间" :formatter="getSETime" width="200"></el-table-column>
                        <el-table-column prop="orderLogistics.receiveTime" label="收货时间" :formatter="getSETime" width="200"></el-table-column>
            
                        </el-table>
                    </el-col>
                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    :current-page.sync="currentPage"  @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>
                </el-row>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr,timefilters} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode,getStaffDTO} from "@/utils/auth";
    import Search from "@/components/Search";

    export default {
        name: 'Info',
        props: ['nationValue','zoneValue','areaValue','elderlyAllType'],
        data() {
            return {
                orderTypeList: [
                    {
                    value: -1, label: '全部订单'
                    }, {
                    value: 1, label: '普通商品订单'
                    }, {
                    value: 2, label: '社会化服务订单'
                    }, 
                ],
                showModal:false,
                tableData:[],
                multipleSelection:'',
                datetimerangeValue:'',
                column:'',
                checked:false,
                zoneProps:{
                    emitPath:false,
                    value: 'zoneCode',
                    // 显示的文字字段名
                    label: 'name',
                    // 子层级字段名
                    children: 'listZoneDTO'
                },
                loading: false, 
                elderlyInfo:[],
                elderlyCode:'',
                totalItems:0,
                pageSize:20,
                currentPage:1,
                bodyStyle:"height:"+(this.$store.state.tableHeight+40)+'px',
                th:this.$store.state.tableHeight+10,
                dayTime:'',
                businessCode:'',
                searchData:[],
                searchForm:{
                    orderType:-1
                },    
                }
        },
        components:{
            Search
        },
        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.bodyStyle = "height:"+(val+40)+'px';
                this.th = val+10;
            },
        },
        methods: {
            init(row){
                this.currentPage=1
                this.searchForm.orderType=-1,
                this.pageIndex=1
                this.dayTime=row.createTime
                this.searchData=[
                    {span:12,name:'订单类型',value:'orderType',type:'select',options:this.orderTypeList},
                ]
                this.getList()
            },
            closeSelf() {
                this.$emit("closeInfo");
                this.$emit("getList");
            },
            getSETime(row, column, cellValue){
                if(cellValue){
                    var time=timefilters(cellValue);
                    if(time=='1970-01-01 08:00:00'){
                        return ''
                    }else{
                        return timefilters(cellValue)
                    }
                }
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },
            //日期格式
            timefilter(row, column, cellValue){
                return timefilters(cellValue)
            },
            allStatus(row,status){
                for(var i in status){
                    if(i==row){
                        return status[i]
                    }
                }
                return "其它";
            },
            statusTitle(row, column, cellValue){
                 return this.allStatus(cellValue,["",'普通商品订单','社会化服务订单','政府购买服务订单']);
            },
            isSchedules(row, column, cellValue){
                 return this.allStatus(cellValue,['否','是']);
            },
            statuss(row, column, cellValue){
                return this.allStatus(cellValue,['待付款','待发货','待收货','交易成功','退款中','交易关闭','交易取消','已评价',"","",'待付款','待接单','已接单','服务中','服务完成','交易取消','已评价']);
            },
            getOrderFrom(row){
            return  row.orderFrom=='xiaole'?'小乐下单':'app下单'
            },
            getList(isSearch){
                if(isSearch)this.currentPage=1
                this.loading=true;
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"OrderBusiness/GetBusinessDayList",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                        businessCode:getStaffDTO().businessCode,
                        dayTime:timefilters(this.dayTime).slice(0,10),
                        orderType:this.searchForm.orderType
                    }
                }).then( (response)=> {
                    this.loading=false;
                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                    }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                }).catch(function (error) {
                    this.loading=false
                    console.log(error);
                });
            },
        }
    }


</script>





<style lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 50px;
        right: 0;
        bottom: 0;
        left: 200px;
        background-color: rgba(0,0,0,.3);
        display: flex;
        z-index: 99;

        .modal {
            background-color: #fff;
            width: 100%;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .modal-body {
                position: relative;
                padding: 20px 20px 0;
                z-index: 99;
            }
            .modal-body /deep/ .el-card.is-always-shadow{
                box-shadow:none;
                border-bottom: none;
                margin-bottom: 20px;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: center;
                padding: 15px;
                display: flex;
                .el-button{
                    width: 15%;
                }
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }

    .mask {
  background-color: rgba(0, 0, 0,.3);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 199
}

.mask .lodingsIcon {
  /* margin-top: 47vh; */
  margin: 47vh auto;
  height: 6vh;
  width: 300px;
  font-size: 18px;
  color: white;
}

.lodingsIcon i {
  z-index: 200;
  font-size: 25px;
  margin-right: 10px;
}


</style>
